import { FormsModule } from '@angular/forms';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { NgClass } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { UserService } from '../../../user/services/user.service';
import { User } from '../../../user/models/user.type';
import { environment } from '../../../../../environments/environment';
import { ImportHistoryComponent } from '../import-history/import-history.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ShopService } from '../../../shop/service/shop.service';
import { TooltipModule } from 'primeng/tooltip';
import { Stepper, StepItem, Step, StepPanel } from 'primeng/stepper';
import { ProgressBarModule } from 'primeng/progressbar';
import { Constants } from '../../../../utils/Constants';
import { Message } from 'primeng/message';
@Component({
  selector: 'app-import-file',
  standalone: true,
  imports: [
    NgClass,
    FormsModule,
    TableModule,
    CardModule,
    TagModule,
    SelectModule,
    FileUploadModule,
    ToastModule,
    DividerModule,
    BadgeModule,
    ButtonModule,
    ImportHistoryComponent,
    ConfirmDialogModule,
    TranslateModule,
    TooltipModule,
    ProgressBarModule,
    Stepper, StepItem, Step, StepPanel,
    Message
  ],
  templateUrl: './import-file.component.html',
  styleUrl: './import-file.component.scss',
  providers: [MessageService, ConfirmationService, TranslateService],
})
export class ImportFileComponent implements OnInit, AfterViewInit {
  user: User;
  active: number = 0;
  files = [];
  totalSize: number = 0;
  totalSizePercent: number = 0;
  url = environment.api_url + 'upload';
  visible = false;
  progress = 0;
  statrtUpload = false;
  @Input()
  shops = [];
  @Input() shopsFilters = [];
  @Input() hasNext : boolean;
  @Input() hideImportModule : boolean;
  @ViewChild(ImportHistoryComponent) importHistoryComponent: ImportHistoryComponent;
  @ViewChild('fileUpload') fileUpload: FileUpload;

  constructor(
    private readonly config: PrimeNG,
    private readonly userService: UserService,
    private readonly messageService: MessageService,
    private readonly confirmationService: ConfirmationService,
    private readonly shopService: ShopService,
    private readonly translate: TranslateService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.user = this.userService.getUser();
  }

  getSelectedShop() {
    if (this.userService.hasRole([Constants.ROLE_SUPER_ADMIN])) {
      const code = this.shopService.getSelectedShopCode();
      return this.shops?.find((shop) => shop.shopCode === code);
    }else {
      const selectedShop = this.shopService.getSelectedShop();
      return selectedShop ?? this.shops[0];
    }
  }

  choose(event, callback) {
    callback();
  }
  resetActive() {
    this.active = 0;
  }

  ngAfterViewInit(): void {
    // Détection manuelle des changements après la vue initialisée
    this.cdr.detectChanges();
  }

  uploadEvent(callback, fileUpload) {
    this.confirmationService.confirm({
      header: this.translate.instant('messages.areYouSure'),
      message:
        '<p> ' + this.translate.instant('importFile.confirmDialogMessage') + '</p><p><b>' +
        this.getSelectedShop().shopName +
        '</b></p>',
      accept: () => {
        callback();
      },
      reject: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.reject'),
          detail: this.translate.instant('messages.rejectSummary'),
          life: 3000,
        });
      },
    });
    this.active = 1;
  }

  onRemoveTemplatingFile(event, file, removeFileCallback, index) {
    removeFileCallback(event, index);
    this.totalSize -= Number.parseInt(this.formatSize(file.size));
    this.totalSizePercent = this.totalSize / 10;
  }

  onClearTemplatingUpload() {
    this.totalSize = 0;
    this.totalSizePercent = 0;
  }

  onTemplatedUpload() {}

  onSelectedFiles(event) {
    this.files = event.currentFiles;
    for (const file of this.files) {
      this.totalSize += Number.parseInt(this.formatSize(file.size));
    }
    this.totalSizePercent = this.totalSize / 10;
  }

  formatSize(bytes) {
    const k = 1024;
    const dm = 3;
    const sizes = this.config.translation.fileSizeTypes;
    if (bytes === 0) {
      return `0 ${sizes[0]}`;
    }

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedSize = Number.parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    return `${formattedSize} ${sizes[i]}`;
  }

  onUpload(event) {}

  uploadFileInChunksRec(file: File): void {
    this.statrtUpload = true;
    const chunkSize = 10 * 1024 * 1024; // 10 MB
    const totalChunks = Math.ceil(file.size / chunkSize);
    let uploadedChunks = 0;
    const uploadChunk = (index: number) => {
      const start = index * chunkSize;
      const end = Math.min(file.size, start + chunkSize);
      const chunk = file.slice(start, end);
      const timestamp = new Date()
        .toLocaleString('fr-FR')
        .replaceAll('/', '-')
        .replaceAll(',', '');

      const lastDotIndex = file.name.lastIndexOf('.');
      const baseName = lastDotIndex === -1 ? file.name : file.name.slice(0, lastDotIndex);
      const extension = lastDotIndex === -1 ? '' : file.name.slice(lastDotIndex);

      const formData = new FormData();
      formData.append('file', chunk);
      formData.append('fileId', `${file.name}`);
      formData.append('chunkIndex', index.toString());
      formData.append('fileName', `${baseName} ${timestamp}${extension}`);
      formData.append('shopCode', this.getSelectedShop().shopCode);
      this.shopService.uploadInChunks(formData).subscribe({
        next: (event) => {
          uploadedChunks++;
            const chunkProgress = Math.round((start / (totalChunks * chunkSize) ) * 100);
            this.progress = Math.round(
              ((uploadedChunks / totalChunks) * 100) + (chunkProgress / totalChunks)
            );
          if (uploadedChunks < totalChunks) {
            uploadChunk(uploadedChunks);
          } else if (uploadedChunks == totalChunks) {
            formData.append('totalChunks', totalChunks.toString());
            this.shopService.finalizeUpload(formData).subscribe({
              next: () => {
                this.loadHistory();
                this.progress = 0;
                this.statrtUpload = false;
                this.fileUpload.clear();
                this.messageService.add({
                  severity: 'success',
                  summary: this.translate.instant('alerts.successSummary'),
                  detail: this.translate.instant('alerts.uploadFileDone'),
                });
              },
            });
          }
          // }
        },
        error: (error) => {
          console.error('Error uploading chunk:', error);
        },
      });
    };

    uploadChunk(0);
  }



  onUploadHandler(event) {
    const files: File[] = event.files;
    this.uploadFileInChunksRec(files[0]);
  }

  onBeforeSend(event: any) {
    event.formData.append('shopCode', this.getSelectedShop());
  }

  loadHistory() {
    this.importHistoryComponent.onLazyLoad({
      first: 0,
      rows: this.importHistoryComponent?.rows,
      sortField: null,
      sortOrder: null,
    });
  }
}
